import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function ArrowRightIcon(props: ACIconProps) {
  return <ACIconWrapper component={IconSvg} {...props} />;
}

const IconSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.2679 6.20748C11.9682 5.92148 11.4935 5.93252 11.2075 6.23214C10.9215 6.53177 10.9325 7.00651 11.2321 7.29252L15.3781 11.25H6.75C6.33579 11.25 6 11.5858 6 12C6 12.4142 6.33579 12.75 6.75 12.75H15.3781L11.2321 16.7075C10.9325 16.9935 10.9215 17.4682 11.2075 17.7679C11.4935 18.0675 11.9682 18.0785 12.2679 17.7925L17.7679 12.5425C17.9161 12.401 18 12.205 18 12C18 11.795 17.9161 11.599 17.7679 11.4575L12.2679 6.20748Z"
        fill="currentColor"
      />
    </svg>
  );
};
